// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"k3-z","displaySixCardTiles":"l3-z"};